import React from 'react'

const SupplierUserLocked: React.FC = () => {
  return (
    <>
      <div className='modal-top'>
        <div className='header pro-head-5' role='heading'>Access Restricted</div>
        <p className='message'>This feature on Procurated is only available to our community of government users.</p>
      </div>
    </>
  )
}

export default SupplierUserLocked
